import hasFullName from '../utilities/hasFullName';

const hasIncludedUser = (attributes) => {
  const properties = { ...attributes };
  return Object.assign(
    properties,
    hasFullName(attributes),
  );
};

export default hasIncludedUser;
